import React from "react";
import {
  WithdrawalHistoryCard,
  WithdrawalHistoryContainer,
  WithdrawalHistoryList,
} from "./WithdrawalHistory.styled";
import { useDispatch, useSelector } from "react-redux";
import { DATETIME_OPTIONS } from "../../constants";
import { useEffect } from "react";
import { getUserHistories } from "../../feature/history/HistoryActions";

const WithdrawalHistory = () => {
  const dispatch = useDispatch();
  const { userHistories } = useSelector((state) => state.history);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    Object.keys(user).length && dispatch(getUserHistories({ user: user }));
  }, [dispatch, user]);

  return (
    <WithdrawalHistoryContainer>
      <WithdrawalHistoryCard>
        {userHistories &&
          userHistories
            .filter((history) => history.tx_type === "withdraw")
            .map((history, index, row) => (
              <WithdrawalHistoryList key={index}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 17L17 7"
                    stroke="#F0BCBC"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M7 7L17 7V17"
                    stroke="#F0BCBC"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span>{history.amount} TRX</span>
                <span>
                  {new Intl.DateTimeFormat("default", DATETIME_OPTIONS).format(
                    new Date(history.date)
                  )}
                </span>
              </WithdrawalHistoryList>
            ))}
      </WithdrawalHistoryCard>
    </WithdrawalHistoryContainer>
  );
};

export default WithdrawalHistory;
